/**
 * Get server name fr given type
 * @param type type of vital data
 */
import { RECORD_TYPE_SETTINGS } from '../../../../../helpers/vital-list-helper';
import { TVitalDataName } from '../../../../../types/life-id';
import { TVitalDataChartType } from '../../../../../types/vital-data';

export function getServerKey(type: TVitalDataChartType) {
  if (type === 'SYSTOLIC') {
    return RECORD_TYPE_SETTINGS.BLOOD_PRESSURE.serverKey[0] as TVitalDataName;
  } else if (type === 'DIASTOLIC') {
    return RECORD_TYPE_SETTINGS.BLOOD_PRESSURE.serverKey[1] as TVitalDataName;
  } else {
    return RECORD_TYPE_SETTINGS[type].serverKey[0] as TVitalDataName;
  }
}
